<template>
  <app-board v-if="amReady">
    <el-row class="p-3">
      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6">
        <dg-select-field
            :control="control"
            :field_span="19"
            :label_span="24"
            :options="destinationsDropDownList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="destinationChanged"
            field_mark="required"
            htmlautocomplete="new-password"
            label="Destination"
            labelProperty="label"
            name="destination_id"
            placeholder="Canada / ATI"
            rules="required"
            valueProperty="value"
        ></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" v-if="!$store.getters['user-state/isUserCustomer']">
        <dg-select-field
            :control="control"
            :field_span="16"
            :label_span="24"
            :options="vendorsList"
            :translateLabel="false"
            :translateLabels="false"
            @amUpdated="vendorChanged"
            field_mark="required"
            label="Vendor"
            name="vendor_id"
            rules="required"></dg-select-field>
      </el-col>

      <el-col :class="$langConfig.cssClass" :span="(!editMode)? 6 : 6" class="pt-2">
        <dg-button class="mr-2 mt-4" :translate="false" text="Reset Search" type="primary" icon="el-icon-refresh" fieldSize="mini" :click="resetSearchFields"></dg-button>
      </el-col>
    </el-row>

    <div class="p-3">
      <div class="row">
        <div class="col-12 col-md-4 pt-2">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" size='mini' v-model="userSearch"></el-input></span>
        </div>
        <div class="col-12 col-md-5">
          <pagination
              :currentPage="currentPage"
              :margin-pages="2"
              :navigateHandler="navigateToPage"
              :page-count="getPagesCount()"
              :page-range="4"
              paginateClass=""></pagination>
        </div>
        <div class="col-12 col-md-3 pt-2 text-right">
          <dg-button class="mr-2" :translate="false" text="Download Destinations" type="success" icon="el-icon-document" fieldSize="mini" :click="downloadWorkingDestinations"></dg-button>
        </div>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </app-board>
</template>

<script>
import Vue from 'vue'
import {AgGridVue} from 'ag-grid-vue';
import actionsCell from './ag-grid/ActionsCell'
import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";
import callTestStatusViewer from "@/components/call-test-status-viewer/View";
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';

let globalContext = null
export default {
  mixins: [fieldController],
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    pagination: () => import('@/components/pagination/View.vue')
  },
  data() {
    return {
      hasColumnBeenResized: 213,
      dataModel: {
        destination_id: '',
        vendor_id: ''
      },
      amReady: false,
      module: {
        ...module
      },
      control: this,
      vendorsList: [],
      destinationsDropDownList: [],
      userSearch: null,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            setTimeout(() => {
              params.api.sizeColumnsToFit()
            }, 200)
          },
          onColumnResized: function (params) {
            if (!globalContext.hasColumnBeenResized) {
              //params.api.sizeColumnsToFit()
              globalContext.hasColumnBeenResized = true
            }
          }
        },
        columnDefs: [
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'vendor',
            headerName:  (($store.getters['user-state/isUserCustomer'])? 'Prefix' : 'Vendor'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            width: 120,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcode',
            width: 120,
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'status',
            width: 120,
            headerName: 'Status',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true,
            cellRendererFramework: Vue.extend(callTestStatusViewer),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          },/*
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: Vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  beforeMount() {
    this.agGridVendorPrefixColumnName =
    globalContext = this;
    this.getVendorDropDownList().then(r => {
      this.vendorsList = r
    })

    this.getDestinationsDropdownlist().then((r) => {
      this.destinationsDropDownList = r
      this.amReady = true
    })

    this.currentPage = parseInt(this.$route.params.listPage)
    this.getGridData()
  },
  methods: {
    getGridData() {
      this.getEntityList({
        page: this.currentPage,
        destination_id: this.dataModel.destination_id,
        vendor_id: this.dataModel.vendor_id
      }).then(response => {
        this.agGrid.rowData = response.rows;
        this.recordsCounter = response.count;
      })
    },
    resetSearchFields () {
      this.fields['destination_id'].field.field_value = ''
      this.fields['destination_id'].field.updateValue()
      this.fields['destination_id'].field.validateMessage = ''

      this.fields['vendor_id'].field.field_value = ''
      this.fields['vendor_id'].field.updateValue()
      this.fields['vendor_id'].field.validateMessage = ''

      this.dataModel.destination_id = ''
      this.dataModel.vendor_id = ''
      this.getGridData()
    },
    destinationChanged() {
      this.getGridData()
    },
    vendorChanged() {
      this.getGridData()
    },
    ...mapActions('voip-vendor-api', {
      getVendorDropDownList: 'getDropDownList'
    }),
    ...mapActions('voip-destination-api', {
      getDestinationsDropdownlist: 'getDropDownList'
    }),
    ...mapActions('voip-vendor-destination-status-api', {
      getEntityList: 'list',
      downloadWorkingDestinations: 'downloadWorkingDestinations'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      $router.push({name: 'module->voip-vendor-destination-status->list->page', params: {listPage: page}})
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
